module.exports = __webpack_public_path__ + "assets/afa7335b8e890a339fe119ac207f85ec.png";